import {KEY_NAME} from '../../native/native_const';

const schamaParamsMap = {
    userinfo: "HybridInfoFeature",
    sessiontimer: "HybridInfoFeature"
};

/**
 * Convert data as query string to the type that Hybrid should got. not support params from not the same feature.
 * @param data
 * @returns {{}}
 */
export function convertQueryStringToObject(data) {
    try {
        let convertedObject = {};

        if (typeof data === 'string' && data.split('?').length === 2) {
            let queryParamsString = data.split('?')[1];
            let queryParamsArr = queryParamsString.split('&');

            queryParamsArr.forEach((param) => {
                let paramObject = param.split('=');
                let paramName = paramObject[0];
                let paramValue = paramObject[1];

                // Remove unrelevant params
                if(schamaParamsMap[paramName.toLowerCase()]) {
                    if(!convertedObject[KEY_NAME.TYPE]) {
                        convertedObject[KEY_NAME.TYPE] = schamaParamsMap[paramName.toLowerCase()];
                    }

                    convertedObject[paramName] = paramValue;
                }
            });

            return data.split('?')[0] + JSON.stringify(convertedObject);
        }

        return data;
    } catch (err) {
        return data;
    }
}
